var isBrowser = typeof window !== 'undefined';
const Foundation = isBrowser ? window.Foundation : {};

var utils = (function() {

    var _isBrowser = typeof window !== 'undefined';

    var _isSurveyCompleted = function(latestScore){
        return latestScore.timeStamp && _getDateKey(latestScore.timeStamp) === _getDateKey();
    }

    var _getDateKey = function(dateStr){
        var d = dateStr ? new Date(dateStr) : new Date();
        return d.getFullYear() + '_' + (d.getMonth() + 1) + '_' + d.getDate();
    }

    var _isSmallScreen = function(){
        return _isBrowser && Foundation && Foundation.MediaQuery && Foundation.MediaQuery.current === 'small';
    }

    return {
        isBrowser: _isBrowser,
        isSurveyCompleted: _isSurveyCompleted,
        isSmallScreen: _isSmallScreen
    };

})();

module.exports = utils;


// WEBPACK FOOTER //
// ./src/common/utils/utils.js